import { render, staticRenderFns } from "./Jewel05.vue?vue&type=template&id=75a750fb&scoped=true&"
import script from "./Jewel05.vue?vue&type=script&lang=js&"
export * from "./Jewel05.vue?vue&type=script&lang=js&"
import style0 from "./Jewel05.vue?vue&type=style&index=0&id=75a750fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a750fb",
  null
  
)

export default component.exports